import client from "./client";

export interface LatencyInfo {
  asr?: number;
  llm?: number;
  tts?: number;
}

export interface InteractResponse {
  session_id: string;
  text_input: string;
  intent: string;
  response_text: string;
  audio_base64?: string;
  audio_format: string;
  backend_used: string;
  latency_ms: LatencyInfo;
}

export interface SessionHistoryItem {
  id: string;
  device_id: string;
  input_type: "voice" | "text";
  text_input?: string;
  response_text?: string;
  backend_used?: string;
  created_at: string;
}

export interface SessionHistoryResponse {
  items: SessionHistoryItem[];
  total: number;
  page: number;
  page_size: number;
}

export const interactApi = {
  /** 文本交互（JWT 认证，统一 Hub 上下文） */
  text: (payload: {
    text: string;
    force_backend?: string;
    with_audio?: boolean;
    session_id?: string;
    audio_format?: string; // "wav" | "mp3" | "pcm"
  }) => {
    const formData = new FormData();
    formData.append("text", payload.text);
    formData.append("force_backend", payload.force_backend || "auto");
    formData.append("with_audio", String(payload.with_audio ?? true));
    formData.append("audio_format", payload.audio_format || "mp3");
    if (payload.session_id) formData.append("session_id", payload.session_id);
    return client
      .post<InteractResponse>("/interact/text", formData)
      .then((r) => r.data);
  },

  /** 语音交互（JWT 认证，统一 Hub 上下文） */
  voice: (formData: FormData, audio_format?: string) => {
    if (audio_format) {
      formData.append("audio_format", audio_format);
    }
    return client
      .post<InteractResponse>("/interact/voice", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data);
  },

  /** 获取设备交互历史 */
  history: (deviceId: string, params?: { page?: number; page_size?: number }) =>
    client
      .get<SessionHistoryResponse>(`/interact/history/${deviceId}`, { params })
      .then((r) => r.data),
};
